import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Button, message, Tooltip } from 'antd';
import { Standard } from 'components/Page';
import { history } from 'store';
import { defaultSettings } from 'views/Roster/timeline/config';
import { clone, dirty } from 'actions';
import config from './config';

const mapDispatchToProps = dispatch => ({
  duplicate(id) {
    return dispatch(clone(REDUCER_KEY.template.key, id));
  },
  reloadList() {
    dispatch(dirty(REDUCER_KEY.templates.key));
  }
});

const Templates = ({ permissions, duplicate, reloadList }) => {
  /*
   ** @description Clone the selected template
   ** @param item {Object} template
    */
  const handleCloneClick = item => duplicate(item.id)
    .then(() => {
      message.success(`Cloning ${item.name} was successful`);
      reloadList();
    })
    .catch(() => message.error(`Cloning ${item.name} failed`));
  return (
    <Standard
      classes="bhp-template"
      canAdmin={permissions.CanAdminActivities()
        .hasPermissions()}
      reducer={{
        item: REDUCER_KEY.template,
        list: REDUCER_KEY.templates
      }}
      scroll={{
        x: 800,
        y: '100%'
      }}
      config={{
        ...config,
        detail: {
          ...config.detail,
          commands: {
            showSaveButton: permissions.CanAdminActivities()
              .hasPermissions(),
            otherButtons: item => permissions.CanAdminActivities()
              .hasPermissions() && (
              <>
                <Tooltip title="Save" placement="bottom">
                  <Button type="primary" size="small" icon="save" onClick={() => history.push(`/roster/templates/timeline/${item.id}`)}>
                    Manage Timeline
                  </Button>
                </Tooltip>
                <Tooltip title="Clone" placement="bottom">
                  <Button className="cloneButton" type="primary" size="small" icon="copy" onClick={() => handleCloneClick(item)}>
                    Clone
                  </Button>
                </Tooltip>
              </>
            )
          }
        }
      }}
      defaultSettings={defaultSettings.filters.activity}
      filterSettings={{
        reducerKey: 'templateCollectionValues',
        placeholder: 'template details',
        themeName: 'template',
        showClearButton: false
      }}
    />
  );
};

Templates.propTypes = {
  duplicate: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  reloadList: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(Templates);
